module.exports = __webpack_public_path__ + "img/service-icon-3.8dc77055.png";